import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue"
  import { find, lowerCase } from "lodash"

  import courtiers from "@/assets/images/ebp/courtiers.svg"
  import dependables from "@/assets/images/ebp/dependables.svg"
  import flame from "@/assets/images/ebp/flame_keepers.svg"
  import gladiator from "@/assets/images/ebp/gladiator.svg"
  import heimdall from "@/assets/images/ebp/heimdall.svg"
  import limitless from "@/assets/images/ebp/limitless.svg"
  import merrymakers from "@/assets/images/ebp/merrymakers.svg"
  import party from "@/assets/images/ebp/party_starters.svg"
  import protectors from "@/assets/images/ebp/protectors.svg"
  import slayers from "@/assets/images/ebp/slayers.svg"
  import spirited from "@/assets/images/ebp/spirited_agents.svg"
  import tribe from "@/assets/images/ebp/tribe.svg"
  import wizards from "@/assets/images/ebp/wizards.svg"
  import fine from "@/assets/images/ebp/fine_craftsmen.svg"
  import timeless from "@/assets/images/ebp/timeless.svg"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'EbgImageObject',
  props: {
    data: {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default() {},
      type: String,
    },
    color: {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default() {},
      type: String,
    },
    label: {
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      default() {},
      type: String,
    },
    height: {
      default() {
        "8rem"
      },
      type: String,
    },
    width: {
      default() {
        "8rem"
      },
      type: String,
    },
  },
  setup(__props) {

const props = __props;

  

  const ebps = [
    { label: "the courtiers", image: courtiers },
    { label: "the dependables", image: dependables },
    { label: "flame keepers", image: flame },
    { label: "the gladiator", image: gladiator },
    { label: "the charioteers", image: heimdall },
    { label: "the limitless", image: limitless },
    { label: "affable merrymakers", image: merrymakers },
    { label: "the party starters", image: party },
    { label: "the protectors", image: protectors },
    { label: "the slayers", image: slayers },
    { label: "spirited agents", image: spirited },
    { label: "the tribe", image: tribe },
    { label: "the wizards", image: wizards },
    { label: "fine craftsmen", image: fine },
    { label: "timeless charmers", image: timeless },
  ]

  const theEBP = computed(() => find(ebps, { label: lowerCase(props.label) }))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "h-32 w-32 masked mx-auto",
    style: _normalizeStyle({
      'background-color': props.color,
      'mask-image': `url(${theEBP.value?.image})`,
      '-webkit-mask-image': `url(${theEBP.value?.image})`,
      height: props.height,
      width: props.width,
    })
  }, null, 4))
}
}

})